import React, { useEffect, useState } from 'react';
import { Link, Navigate, useLocation, useParams } from 'react-router';
import { ArrowLeft, Headphones, Share2, Square } from 'lucide-react';
import { getBibleReaderPath } from '../services/bibleReaderService';
import { playVerse, stopVerse } from '../services/ttsService';

// Old generic reader links must still open real content after a reload. Keep
// explicitly supplied delivery content intact instead of substituting a sample.
export default function SharedReader() {
  const { contentType = 'verse' } = useParams();
  const { state } = useLocation();
  const [speaking, setSpeaking] = useState(false);
  const [message, setMessage] = useState('');
  const item = state?.entry;
  const destinations = { verse: '/bible/verse-of-the-day', prayer: '/prayer', devotional: '/devotionals' };

  useEffect(() => () => stopVerse(), []);

  if (!item?.text) return <Navigate to={destinations[contentType] || '/'} replace />;

  const listen = async () => {
    if (speaking) { stopVerse(); setSpeaking(false); return; }
    setSpeaking(true);
    setMessage('');
    try {
      await playVerse({
        text: item.text,
        reference: item.reference || '',
        onEnd: () => setSpeaking(false),
        onError: () => { setSpeaking(false); setMessage('This reading could not be played aloud.'); }
      });
    } catch (error) {
      setSpeaking(false);
      setMessage(error.message || 'This reading could not be played aloud.');
    }
  };

  const share = async () => {
    try {
      await navigator.share({ title: item.title || item.reference, text: `${item.text}\n${item.reference || ''}` });
    } catch (error) {
      if (error.name !== 'AbortError') setMessage('This reading could not be shared.');
    }
  };

  return (
    <main className="shared-reader">
      <header>
        <Link to={destinations[contentType] || '/'}><ArrowLeft /> Back to today</Link>
        <nav aria-label="Reading tools">
          <button type="button" aria-label={speaking ? 'Stop listening' : 'Listen'} onClick={listen}>{speaking ? <Square /> : <Headphones />}</button>
          {typeof navigator.share === 'function' ? <button type="button" aria-label="Share" onClick={share}><Share2 /></button> : null}
        </nav>
      </header>
      {message ? <p role="status">{message}</p> : null}
      <article>
        <h1>{item.title || item.reference || 'Your reading'}</h1>
        <blockquote>{item.text}<cite>{item.reference}</cite></blockquote>
        {item.reflection ? <p>{item.reflection}</p> : null}
        {item.prayer ? <><h2>Prayer</h2><p>{item.prayer}</p></> : null}
        {item.reference ? <Link to={getBibleReaderPath(item.reference)}>Read the full chapter</Link> : null}
      </article>
      <aside><div><strong>Make time for a verse.</strong><span>Email delivery is optional.</span></div><Link to="/schedule?type=verse">Schedule a verse</Link></aside>
    </main>
  );
}
